import { apiClient } from "../../api";

/** React Query key for the current user's cart (`GET /cart/me`). */
export const cartQueryKey = {
  current: ["cart", "me"],
};

export const CART_QUERY_KEY = cartQueryKey.current;

/**
 * Get current user's cart
 * @returns {Promise<import("./types").Cart|null>} Cart object or null if no cart exists
 */
export async function getMyCart() {
  try {
    const response = await apiClient.get("/cart/me");
    return response.data;
  } catch (error) {
    // Handle 404 (no cart exists) gracefully
    if (error.response?.status === 404) {
      return null;
    }
    throw error;
  }
}

/**
 * Update cart (add/update/remove item)
 * @param {Object} params
 * @param {number} params.productId - Product ID to add/update/remove
 * @param {number} params.quantity - Quantity (0 to remove, >0 to add/update)
 * @returns {Promise<import("./types").Cart>} Updated cart object
 */
export async function updateCart({ productId, quantity }) {
  const response = await apiClient.patch("/cart/update", {
    productId,
    quantity,
  });
  return response.data;
}

/**
 * Add item to cart (convenience function)
 * @param {Object} params
 * @param {number} params.productId - Product ID to add
 * @param {number} params.quantity - Quantity to add
 * @returns {Promise<import("./types").Cart>} Updated cart object
 */
export function addToCart({ productId, quantity }) {
  return updateCart({ productId, quantity });
}

/**
 * Remove item from cart (convenience function)
 * @param {Object} params
 * @param {number} params.productId - Product ID to remove
 * @returns {Promise<import("./types").Cart>} Updated cart object
 */
export function removeFromCart({ productId }) {
  return updateCart({ productId, quantity: 0 });
}
